import sticky from './_sticky';

export function stickySidebar() {
  const spacingEl = document.querySelector('.sticky-margin');
  let spacing = 0;
  if(spacingEl) spacing = spacingEl.clientHeight

  const sidebar = document.querySelector('.sticky-sidebar');
  if(sidebar) {
    new sticky(sidebar, {
      topSpacing: spacing*1.5,
      bottomSpacing: spacing,
      containerSelector: '.sticky-container',
      minWidth: 1438
    });
  }

  const sidebarSingle2 = document.querySelector('.sticky-sidebar-single2');
  if(sidebarSingle2) {
    new sticky(sidebarSingle2, {
      topSpacing: spacing*1.5,
      bottomSpacing: spacing,
      containerSelector: '.sticky-container',
      minWidth: 1023
    });
  }
  
  const sidebarAccessMap = document.querySelector('.sticky-sidebar-accessmap');
  if(sidebarAccessMap) {
    new sticky(sidebarAccessMap, {
      topSpacing: spacing,
      bottomSpacing: 0,
      containerSelector: '.sticky-container',
      minWidth: 1023
    });
  }
}